import styled from "styled-components";
import { MenuColor } from "../hook/useEditTournament";
import { PageWrapper } from "../../../styles/page";

export const Wrapper = styled(PageWrapper)``;

export const EditTimerWrapper = styled.div`
  width: 100%;
  height: 100vh;
  > .button-wrapper {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;

    > .button {
      cursor: pointer;
      padding: 12px;
      color: white;
      border-radius: 8px;
      font-size: 16px;
    }
    > .button.pink {
      background-color: #f3486a;
    }
    > .button.green {
      background-color: #35c31e;
    }
    > .button.pink:hover {
      background-color: #d03f5e;
    }

    > .button.green:hover {
      background-color: #2ca318;
    }
  }
  > .body {
    width: 100%;
    margin-top: 80px;
    background-color: #14141b;
    padding: 40px 60px;

    > .title {
      color: #fff;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > .custom-wrapper {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      gap: 40px;
    }
  }
`;

export const CustomTimerColorWrapper = styled.div<MenuColor>`
  flex: 1;
  display: flex;
  flex-direction: column;
  > .header {
    color: #fff;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .custom-select-wrapper {
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > .menu-custom-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
      flex: 0.8;
      > .item {
        display: flex;
        flex-direction: column;
        gap: 20px;
        > .title {
          color: #fff;
          font-family: Pretendard;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
    }
    > .background-custom-wrapper {
      flex: 0.85;
      display: flex;
      flex-direction: column;
      gap: 20px;

      > .custom-file-image {
        width: 128px;
        height: 128px;
      }

      > .custom-color-image {
        width: 128px;
        height: 128px;

        > div {
          width: 128px;
          height: 128px;
        }
      }

      > .title {
        color: #fff;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }

  > .custom-list-wrapper {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
    > .item {
      width: 342px;
      height: 192px;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
      }
      > .check {
        width: 27px;
        height: 27px;
        position: absolute;
        bottom: 5px;
        right: 5px;
      }
    }

    > .item.select {
      border: 2px solid #bb1717;
    }
  }
`;

export const CustomTimerItem = styled.div<MenuColor>`
  width: 879px;
  height: 510px;
  //background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px 47px;
  color: ${(props) => props.fontColor};
  font-family: Pretendard;
  > .header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    > .pub-name {
      color: white;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > img {
      width: 77px;
      height: 27px;
    }
  }

  > .middle {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-top: 17px;
    > .left {
      width: 566px;
      height: 276px;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      background: ${(props) => props.menu1Color};
      box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);

      > .top {
        padding: 20px 0px 45px 23px;
        margin-right: 25px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        > .game-type {
          font-weight: 900;
          font-size: 23.6px;
        }

        > .info {
          display: flex;
          flex-direction: row;
          gap: 24px;
          font-size: 14px;
          > span {
            font-weight: 700;
          }
          > .level {
            font-weight: 300;

            > span {
              font-weight: 700;
            }
          }
        }
      }

      > .timer-wrapper {
        padding: 0px 0 24px;
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 38.54px;
        position: relative;
        > .now-level-wrapper {
          margin-left: 23px;
          border-radius: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          width: 104.607px;
          height: 104.574px;
          background: ${(props) => props.boxColor};
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          > title {
            text-align: center;
            font-size: 17px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          > .now-level {
            font-size: 38px;
            font-weight: 700;
            line-height: normal;
          }
        }

        > .timer {
          top: -35px;
          // left: 187px;
          right: 17.69px;
          position: absolute;
          font-size: 147.521px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
      }

      > .next-break {
        margin-left: 22px;
        margin-right: 22px;
        padding: 5px 0;
        color: white;
        font-size: 14.177px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 22px;
        border: 1px solid var(--Purple-300, #6436e7);
        background: ${(props) => props.buttonColor};
      }
    }
    > .right {
      width: 297px;
      height: 276px;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      background: ${(props) => props.menu2Color};
      box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
      display: flex;
      flex-direction: column;
      > .title {
        padding: 20px;
        font-size: 18.902px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      > .prize-list {
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 4.73px;
        font-size: 11.814px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        > .item {
          display: flex;
          flex-direction: row;
          gap: 8px;
          > .rank {
            width: 41px;
          }
          > .prize-wrapper {
            display: flex;
            flex-direction: row;

            > .sub-prize {
              margin-left: 30px;
              display: flex;
              align-items: center;
              height: 12.67px;
              padding: 0 9.45px;
              border-radius: 21.265px;
              border: 0.473px solid var(--Purple-300, #6436e7);
              background: var(--Purple-300, #6436e7);
              font-size: 7.088px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }
          }
        }
      }
    }
  }

  > .bottom {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    > .left {
      width: 566px;
      height: 168px;
      display: flex;
      flex-direction: row;
      gap: 16px;

      > .item {
        width: 50%;
        height: 100%;
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.3);
        box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 17.69px;
      }

      > .item.a {
        background: ${(props) => props.menu3Color};
        > .title {
          text-align: center;
          font-size: 23.628px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        > .blind {
          text-align: center;
          font-size: 30.716px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
      > .item.b {
        background: ${(props) => props.menu4Color};
        > .title {
          text-align: center;
          font-size: 23.628px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        > .blind {
          text-align: center;
          font-size: 30.716px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
    }
    > .right {
      width: 297px;
      height: 168px;
      display: flex;
      flex-direction: row;
      gap: 16px;

      > .item {
        flex: 1;
        height: 100%;
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.3);
        background: ${(props) => props.menu1Color};
        box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);

        > .list {
          display: flex;
          flex-direction: column;
          margin-top: 25px;
          margin-left: 16px;
          gap: 4.73px;

          > .box {
            display: flex;
            flex-direction: column;

            > .title {
              font-size: 9.451px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            > .value {
              font-size: 11.814px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
            }
          }
        }
      }
      > .item.a {
        background: ${(props) => props.menu5Color};
      }
      > .item.b {
        background: ${(props) => props.menu6Color};
      }
    }
  }
`;

export const EditConfigWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 104px);
  > .header {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    > .title {
      color: white;
      font-weight: 700;
      font-size: 20px;
    }

    > .button {
      border-radius: 0.375rem;
      padding: 10px;
      color: white;
      font-weight: 500;
      font-size: 16px;
      background-color: #f3486a;
    }
  }

  > .button-wrapper {
    padding: 20px 0 50px;
    display: flex;
    justify-content: flex-end;
    color: white;

    > .button {
      cursor: pointer;
      border-radius: 6px;
      padding: 8px;
      background-color: #35c31e;
    }
  }

  > .wrapper {
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #141c33;
    padding: 20px;

    font-family: Pretendard;
    min-height: 10px;
    display: flex;
    flex-direction: row;
    > .section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;

      > .item {
        width: 100%;
        min-height: 40px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        > .title {
          font-size: 16px;
          color: white;
        }

        > .list-wrapper {
          display: flex;
          flex-direction: column;
          > .list {
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            gap: 5px;

            > .level-limit-item {
              display: flex;
              flex-direction: row;
              gap: 7px;
              align-items: center;
              > .input {
                width: 50%;
                font-size: 16px;
                border-radius: 4px;
                border: 1px solid #dedede;
                padding: 8px;
                max-width: 500px;
                background-color: transparent;
                color: white;
              }
              > .input.sub {
                width: 20%;
              }
              > span {
                font-weight: 550;
                font-size: 16px;
                color: #8a92ab;
              }

              > .level {
                width: 38px;
              }

              > .sub-prize {
                margin-left: 10px;
              }
            }
          }
          > .button-wrapper {
            border-radius: 6px;
            display: flex;
            flex-direction: row;
            align-items: center;
            > span {
              color: #8a92ab;
              margin-left: 10px;
            }
            > .minus-box {
              cursor: pointer;
              border-radius: 5px 0 0 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 36px;
              height: 36px;
              background-color: #8a92ab;
              border: 1px solid #8a92ab;
            }
            > .date {
              border: 1px solid #8a92ab;
              height: 36px;
              width: 60px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: white;
            }

            > .plus-box {
              border: 1px solid #8a92ab;
              cursor: pointer;
              border-radius: 0 5px 5px 0;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #8a92ab;
              width: 36px;
              height: 36px;
            }
          }
        }

        > .input-wrapper {
          width: 100%;
          display: flex;
          flex-direction: row;
          gap: 5px;
          align-items: center;
          > span {
            color: #8a92ab;
          }
          > .input {
            width: 100%;
            font-size: 16px;
            border-radius: 4px;
            border: 1px solid #dedede;
            padding: 8px;
            max-width: 500px;
            background-color: transparent;
            color: white;
          }
        }

        > .input {
          font-size: 16px;
          border-radius: 4px;
          border: 1px solid #dedede;
          padding: 8px;
          max-width: 500px;
          background-color: transparent;
          color: white;
        }

        > .check-box-wrapper {
          display: flex;
          flex-direction: row;
          gap: 5px;
          > span {
            color: #8a92ab;
          }
        }

        > .select {
          display: flex;
          flex-direction: row;
          gap: 10px;
          > label {
            display: flex;
            flex-direction: row;
            gap: 3px;
            > .name {
              font-size: 16px;
              color: #8a92ab;
              font-weight: 400;
            }

            input[type="radio"] {
              flex-shrink: 0;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              width: 13px;
              height: 13px;
              border: 2px solid #8a92ab;
              border-radius: 50%;
              outline: none;
              cursor: pointer;
            }

            input[type="radio"]:checked {
              background-color: #111;
              border: 3px solid #fff;
              box-shadow: 0 0 0 1px #111;
            }
          }
        }

        > .date {
          display: flex;
          flex-direction: row;
          gap: 7px;
          align-items: center;

          > span {
            font-size: 16px;
            color: #8a92ab;
          }

          > .item {
            border: 1px solid #8a92ab;
            border-radius: 6px;
            display: flex;
            flex-direction: row;
            > .minus-box {
              cursor: pointer;
              border-radius: 5px 0 0 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 36px;
              height: 36px;
              background-color: #8a92ab;
            }
            > .date {
              height: 36px;
              width: 60px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: white;
            }

            > .plus-box {
              cursor: pointer;
              border-radius: 0 5px 5px 0;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #8a92ab;
              width: 36px;
              height: 36px;
            }
          }
        }
      }
    }
  }
`;

export const EditPageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  gap: 15px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: #b7b7b7;
  padding-bottom: 10px;

  > img {
    cursor: pointer;
  }
`;

export const EndPopup = styled.div`
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 514px;
  height: 275px;
  border-radius: 13px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 55px;

  > .content {
    font-family: Pretendard;
    font-size: 25px;
    font-weight: 600;
    text-align: center;
    line-height: 35px;
  }

  > .button-group {
    display: flex;
    gap: 8px;
    justify-content: center;
    padding-top: 45px;

    > .button {
      width: 238px;
      height: 48px;
      gap: 10px;
      border-radius: 8px;
      color: #6436e7;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 600;
      line-height: 48px;
      cursor: pointer;

      &.purple {
        background: #6436e7;
        color: #fff;
      }
    }
  }
`;

export const EditTournamentDiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const EditTournamentDiscountItem = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 15px;
`;
